export default __webpack_public_path__ + "static/media/mba-hero-v3.f0971eee.jpg";